import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Spinner, Card, Container, Row, Col } from 'react-bootstrap';
import Layout from '../NewHeader/Layout';
import './POSBilling.css';
import slotimg from "../../images/shawarma/sh1.png";
import slotimg1 from "../../images/sandwich/s2.png";
import slotimg2 from "../../images/lunch/lunch3.png";
import axios from 'axios';
import { var_api, image_api } from '../constant';
import { useHistory } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import Swal from 'sweetalert2';

const POSBilling = () => {
 // Import statements and other existing code remains
const [loading, setLoading] = useState(false);
const history = useHistory();
// Add this near top
const [categories, setCategories] = useState([]);
const [activeCategoryId, setActiveCategoryId] = useState('all');
const [allFoods, setAllFoods] = useState([]);
const [showOrganic, setShowOrganic] = useState({});

const [cartItems, setCartItems] = useState([]);
const [showCartModal, setShowCartModal] = useState(false);
const [customerName, setCustomerName] = useState("");
const [mobile, setMobile] = useState("");
const [payModes, setPayModes] = useState([]);
const [selectedPayMode, setSelectedPayMode] = useState("");
const [taxAmount, setTaxAmount] = useState(0);
const [chargeAmount, setChargeAmount] = useState(0);
const [taxDetails, setTaxDetails] = useState([]);
const [chargeDetails, setChargeDetails] = useState([]);


const [showImages, setShowImages] = useState(true);



const togglePriceType = (foodId) => {
    setShowOrganic((prev) => ({
      ...prev,
      [foodId]: !prev[foodId],
    }));
  };

useEffect(() => {
  fetchCategories();
  fetchTables();
}, []);

const fetchTables = async (id) => {
  const token = localStorage.getItem('Token');
  console.log(id)
  const shopId =localStorage.getItem('ShopId');
  try {
     const shop = localStorage.getItem('ShopId')
     const response = await axios.get(`${var_api}paymode-master/get/${shopId}`,{
      headers:{
        Authorization:`${token}`
      }
     });
     console.log("response",response)
    const user =response.data.data;
    setPayModes(user);
    
  } catch (error) {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
    setPayModes([])
  }
};


const fetchCategories = async () => {
  setLoading(true);
  const shop_id = localStorage.getItem('ShopId');
  const token = localStorage.getItem('Token');

  try {
    const response = await axios.get(`${var_api}pos-all-categories/${shop_id}`, {
      headers: {
        Authorization: `${token}`,
      },
    });
    const catData = response.data.data;
    setCategories(catData);

    // Flatten all foods into a single array
    const mergedFoods = catData.flatMap(cat => cat.foods.map(food => ({
      ...food,
      category_id: cat.category_id
    })));
    setAllFoods(mergedFoods);

    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.error("Error fetching categories:", error);
  }
};

const handleCategoryClick = (categoryId) => {
  setActiveCategoryId(categoryId);
};

const filteredFoods = activeCategoryId === 'all'
  ? allFoods
  : allFoods.filter(f => f.category_id === activeCategoryId);

 const addToCart = (food) => {
  const foodId = food.food_id;
  const variantId = food.variant_id || "base";

  setCartItems((prevItems) => {
    const existingIndex = prevItems.findIndex(
      (item) => item.food_id === foodId && (item.variant_id || "base") === variantId
    );

    if (existingIndex !== -1) {
      // If item exists, update its quantity
      const updatedItems = [...prevItems];
      updatedItems[existingIndex] = {
        ...updatedItems[existingIndex],
        quantity: (updatedItems[existingIndex].quantity || 1) + 1,
      };
      return updatedItems;
    } else {
      // If item doesn't exist, add it with quantity = 1
      return [...prevItems, { ...food, quantity: 1 }];
    }
  });
};


const getEffectivePrice = (item) => {
  const key = `${item.food_id}-${item.variant_id || "base"}`;
  const isOrganic = showOrganic[key] !== false;
  return isOrganic 
    ? (item.variant_organic_price || item.organic_price || item.variant_price || item.price)
    : (item.variant_price || item.price);
};

const totalCartPrice = cartItems.reduce((sum, item) => {
  return sum + getEffectivePrice(item) * (item.quantity || 1);
}, 0);



const placeOrder = async () => {
  const token = localStorage.getItem("Token");
  const shop_id = localStorage.getItem("ShopId");

  // Get today's date & time
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const order_date = `${day}-${month}-${year}`; // dd-mm-yyyy
  const order_time = today.toTimeString().slice(0, 8); // hh:mm:ss

  // Calculate total and sub_total
  const getEffectivePrice = (item) => {
    const key = `${item.food_id}-${item.variant_id || "base"}`;
    const isOrganic = showOrganic[key] !== false;
    return isOrganic
      ? (item.variant_organic_price || item.organic_price || item.variant_price || item.price)
      : (item.variant_price || item.price);
  };

  const sub_total = cartItems.reduce((sum, item) => {
    return sum + getEffectivePrice(item) * item.quantity;
  }, 0);

    // 🔹 Fetch tax & charge amounts
  const {
    taxDetails,
    chargeDetails,
    totalTaxAmount,
    totalChargeAmount
  } = await calculateTaxesAndCharges(sub_total);
  setTaxDetails(taxDetails);
  setChargeDetails(chargeDetails);

    const totalAmount = sub_total + totalTaxAmount + totalChargeAmount;

  const payload = {
    shop_id,
    order_date,
    order_time,
    delivery_address: "-", // or get from input
    order_type: 1, // or your default
    customer_name: customerName || "-",
    mobile_no: mobile || "-",
    customer_id: 0, // or actual logged in customer ID
    sub_total:sub_total,
    amount: totalAmount,
    payment_status: 1, // e.g. 1 for success, 0 for pending
    paymode_id: selectedPayMode,
    order_status: 0, // e.g. 1 for new, or whatever your system uses
    approval_status:0,
    is_refund:0,
    remark: "-",
    reject_remarks:"-",
    refund_id: 0,
    credit_order_id: null,
    tax_amount: totalTaxAmount,
    delivery_charge_amount: totalChargeAmount,
    booking_dates: [
      {
        date: order_date,
        slots: [
          {
            slot_id: 0,
            slot_name: "Immediate",
            ordered_items: cartItems.map((item) => ({
              food_id: item.food_id,
              food_name: item.food_name,
              category_id: item.category_id || 0,
              sub_category_id: item.sub_category_id || 0,
              quantity: item.quantity,
              unit_price: getEffectivePrice(item),
              is_variant: item.is_variant || 0,
              variant_id: item.variant_id || 0,
              variant_name: item.variant_name || "-",
              item_code: item.item_code || "-",
              remark: item.remark || "-",
              additional_notes: item.additional_notes || "-",
              is_organic: showOrganic[`${item.food_id}-${item.variant_id || "base"}`] !== false ? 1 : 0,
              sub_variant_name: item.sub_variant_name || "-",
              sub_variant_id: item.sub_variant_id || 0,
              sub_group_foods: item.sub_group_foods || [],
            })),
          },
        ],
      },
    ],
     taxes: taxDetails,
    charges: chargeDetails,
    transaction_id: "-", // Optional
    transaction_name: "-", // Optional
    remark: "-", // Optional
    is_customer: 0, // or 0
  };

  try {
    await axios.post(`${var_api}booking-orders/place-order`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
 Swal.fire('Success', 'Order placed successfully!', 'success');
    setCartItems([]);
    setCustomerName("");
    setMobile("");
    setSelectedPayMode("");
    setShowCartModal(false);
  } catch (err) {
    console.error("Order failed:", err?.response?.data || err.message);
    Swal.fire('Error', 'Failed to place order.', 'error');
  }
};


const updateQuantity = (index, newQuantity) => {
  if (newQuantity < 1) {
    // If quantity would be less than 1, remove the item instead
    const updatedCart = [...cartItems];
    updatedCart.splice(index, 1);
    setCartItems(updatedCart);
  } else {
    // Update the quantity for the item
    const updatedCart = cartItems.map((item, i) => 
      i === index ? { ...item, quantity: newQuantity } : item
    );
    setCartItems(updatedCart);
  }
};

const calculateTaxesAndCharges = async (subTotal) => {
  try {
    const [taxRes, chargeRes] = await Promise.all([
      axios.get(`${var_api}tax-master/get-active/1`),
      axios.get(`${var_api}delivery-charge/get-active/1`)
    ]);

    const taxes = taxRes.data || [];
    const charges = chargeRes.data || [];

    let totalTaxAmount = 0;
    let totalChargeAmount = 0;

    const taxDetails = taxes.map((tax) => {
      const value = tax.discount_type == 1 // 1 = percentage
        ? (subTotal * tax.value) / 100
        : tax.value;

      totalTaxAmount += value;

      return {
        tax_id: tax.id,
        tax_name: tax.tax_name,
        tax_amount: parseFloat(value.toFixed(2)),
      };
    });

    const chargeDetails = charges.map((charge) => {
      const value = charge.discount_type == 1
        ? (subTotal * charge.value) / 100
        : charge.value;

      totalChargeAmount += value;

      return {
         charges_id: charge.id,
        charges_name: charge.charge_name,
        charges_amount: parseFloat(value.toFixed(2)),
      };
    });

    console.log("charges and taxex", taxDetails,chargeDetails,totalTaxAmount,totalChargeAmount, charges, taxes);

    return {
      taxDetails,
      chargeDetails,
      totalTaxAmount: parseFloat(totalTaxAmount.toFixed(2)),
      totalChargeAmount: parseFloat(totalChargeAmount.toFixed(2))
    };
  } catch (error) {
    console.error("Error fetching taxes or charges", error);
    return {
      taxDetails: [],
      chargeDetails: [],
      totalTaxAmount: 0,
      totalChargeAmount: 0
    };
  }
};

useEffect(() => {
  const updateTaxesAndCharges = async () => {

     if (cartItems.length === 0) return;

    const subTotal = cartItems.reduce((sum, item) => {
      const key = `${item.food_id}-${item.variant_id || "base"}`;
      const isOrganic = showOrganic[key] !== false;
      const price = isOrganic
        ? (item.variant_organic_price || item.organic_price || item.variant_price || item.price)
        : (item.variant_price || item.price);
      return sum + price * item.quantity;
    }, 0);

    const {
       taxDetails,
      chargeDetails,
      totalTaxAmount,
      totalChargeAmount
    } = await calculateTaxesAndCharges(subTotal);

    setTaxAmount(totalTaxAmount);
    setChargeAmount(totalChargeAmount);
      setTaxDetails(taxDetails);
    setChargeDetails(chargeDetails);
  };

  if (cartItems.length > 0 && showCartModal) {
    updateTaxesAndCharges();
  }
}, [cartItems, showCartModal]);



return (
  <Layout>
    <div className="container mt-1">
      {/* <h4 className='ushe'>POS Billing</h4> */}
      <br/>

      {/* Category Navigation */}
     <div className="d-flex flex-wrap justify-content-start gap-2 mb-4">
  <div
    className={`category-card ${activeCategoryId === 'all' ? 'active' : ''}`}
    onClick={() => handleCategoryClick('all')}
  >
    <span>All</span>
  </div>
  {categories.map((category) => (
    <div
      key={category.category_id}
      className={`category-card ${activeCategoryId === category.category_id ? 'active' : ''}`}
      onClick={() => handleCategoryClick(category.category_id)}
    >
      <span>{category.category_name}</span>
    </div>
  ))}
</div>



      {/* Food Items */}
    <div className="row g-2 mx-0">
      {filteredFoods.map((food) => {
        const foodId = `${food.food_id}-${food.variant_id || "base"}`;
        const hasVariant = food.variant_price && food.variant_price > 0;

        // Price values
        const regularPrice = hasVariant ? food.variant_price : food.price;
        const organicPrice = hasVariant ? food.variant_organic_price : food.organic_price;

        const isShowingOrganic = showOrganic[foodId] !== false; // default is true (organic)

        return (
          <div
            className="col-6 col-sm-4 col-md-3 col-lg-2 px-3"
            key={foodId}
          >
            <div
              className="card h-100 border border-success shadow-sm rounded-3 overflow-hidden mx-0"
              style={{ width: "100%", maxWidth: "220px", fontSize: "0.9rem" }}
            >
              {/* Image with Organic Badge */}
              {showImages && (
              <div className="position-relative" style={{ height: "140px", overflow: "hidden" }}>
                <img
                  src={food.food_image ? `${image_api}${food.food_image}` : slotimg}
                  className="img-fluid w-100 h-100 object-fit-cover"
                  alt={food.food_name}
                />
                {/* {(organicPrice && organicPrice > 0) && isShowingOrganic && ( */}
                  <span className={`position-absolute top-0 end-0 px-2 py-1 small fw-bold ${
    isShowingOrganic ? "bg-success text-white" : "bg-warning text-dark"
  }`} onClick={() => togglePriceType(foodId)}>
                    {isShowingOrganic ? "Organic" : "Regular"}
                  </span>
                {/* )} */}
              </div>
              )}

              {/* Card Body */}
              <div className="card-body d-flex flex-column p-2">
                <div className="mb-2">
                  <h6 className="mb-1 text-dark" style={{ fontSize: "0.95rem" }}>
                    <b style={{ fontSize: "1.2rem" }}>{food.food_name}</b>
                    {food.variant_name && (
                      <span className="text-muted small" > • {food.variant_name}</span>
                    )}
                  </h6>
                  {food.description && (
                    <p
                      className="small text-muted mb-2 line-clamp-2"
                      style={{ WebkitLineClamp: 2, fontSize: "0.75rem" }}
                    >
                      {food.description}
                    </p>
                  )}
                </div>

                {/* Pricing Section */}
                <div className="mt-auto">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <span className="fw-bold text-success" style={{ fontSize: "1.3rem" }}>
                        ₹{isShowingOrganic && organicPrice > 0 ? organicPrice : regularPrice}
                      </span>
                      {isShowingOrganic && (
                        <span className="text-muted small ms-2">({hasVariant ? "Variant" : "Base"})</span>
                      )}
                    </div>
                    {/* <div>
                      {food.is_additional_notes === 1 && (
                        <span className="badge bg-warning text-dark small me-1">Notes</span>
                      )}
                      {food.is_group === 1 && (
                        <span className="badge bg-info text-white small">Group</span>
                      )}
                    </div> */}
                  </div>

                  {/* Toggle Button */}
                  {/* {(organicPrice && organicPrice > 0) && (
                    <Button
                      variant="secondary"
                      size="sm"
                      className="mb-2 w-100"
                      onClick={() => togglePriceType(foodId)}
                    >
                      Show {isShowingOrganic ? "Regular Price" : "Organic Price"}
                    </Button>
                  )} */}

                  <Button
                    variant="outline-success"
                    className="w-100 rounded-pill fw-bold"
                    size="sm"
                     onClick={() => addToCart(food)}
                  >
                    + Add to Order
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>



    </div>

    <div className="position-fixed top-0 end-3 m-3 z-index-999">
  <Button variant="success" onClick={() => setShowCartModal(true)}>
    <FaShoppingCart /> ({cartItems.length}) ₹{totalCartPrice}
  </Button>
</div>

<div className='position-fixed top-0 m-3 z-index-999' style={{right:"100px"}}>
    <div className="form-check form-switch mb-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="imageToggle"
    checked={showImages}
    onChange={() => setShowImages(!showImages)}
  />
  <label className="form-check-label" htmlFor="imageToggle">
    Show Img
  </label>
</div>

</div>



<Modal show={showCartModal} onHide={() => setShowCartModal(false)} size='lg' centered backdrop="static">
  <Modal.Header closeButton className="border-bottom-0 pb-0">
    <Modal.Title className="fw-bold fs-4 text-dark">Order Summary</Modal.Title>
  </Modal.Header>
  <Modal.Body className="p-0">
    <div className="sticky-top bg-white p-4 border-bottom">
      <div className="row g-3">
        <div className="col-md-4">
          <div className="form-floating">
            <input
              type="text"
              className="form-control border-2"
              id="customerName"
              placeholder="Customer Name"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
            <label htmlFor="customerName" className="text-muted">Customer Name</label>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-floating">
            <input
              type="tel"
              className="form-control border-2"
              id="mobileNumber"
              placeholder="Mobile Number"
              value={mobile}
              // onChange={(e) => setMobile(e.target.value)}
              onChange={(e) => {
        const onlyDigits = e.target.value.replace(/\D/g, ''); // remove non-digit characters
        setMobile(onlyDigits);
      }}
            />
            <label htmlFor="mobileNumber" className="text-muted">Mobile Number</label>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-floating">
            <select
              className="form-select border-2"
              id="paymentMode"
              value={selectedPayMode}
              onChange={(e) => setSelectedPayMode(e.target.value)}
            >
              <option value="">Select Payment Mode</option>
              {payModes.map((mode) => (
                <option key={mode.id} value={mode.id}>{mode.name}</option>
              ))}
            </select>
            <label htmlFor="paymentMode" className="text-muted">Payment Mode</label>
          </div>
        </div>
      </div>
    </div>

    {cartItems.length === 0 ? (
      <div className="text-center py-5">
        <i className="bi bi-cart-x text-muted" style={{ fontSize: "3.5rem", opacity: 0.5 }}></i>
        <p className="mt-3 text-muted fs-5">Your cart is empty</p>
      </div>
    ) : (
      <div className="p-4">
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            <thead>
              <tr className="text-uppercase small text-muted border-top border-bottom border-light">
                <th style={{ width: "60px" }}></th>
                <th>Item</th>
                <th className="text-end" style={{ width: "100px" }}>Price</th>
                <th className="text-center" style={{ width: "120px" }}>Quantity</th>
                <th className="text-end" style={{ width: "100px" }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item, index) => {
                const price = (showOrganic[`${item.food_id}-${item.variant_id || "base"}`] !== false && 
                              (item.variant_organic_price || item.organic_price)) || 
                              (item.variant_price || item.price);
                return (
                  <tr key={index} className="border-bottom border-light">
                    <td>
                      <div className="rounded-2 overflow-hidden" style={{ width: "50px", height: "50px" }}>
                        <img
                          src={item.food_image ? `${image_api}${item.food_image}` : slotimg}
                          alt={item.food_name}
                          className="w-100 h-100 object-fit-cover"
                          style={{borderRadius:"30px"}}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="fw-semibold">{item.food_name}</div>
                      <small className="text-muted">{item.variant_name || "Standard"}</small>
                    </td>
                    <td className="text-end">₹{price.toFixed(2)}</td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center">
                        <button 
                          className="btn btn-sm btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "28px", height: "28px" }}
                          onClick={() => updateQuantity(index, item.quantity - 1)}
                        >
                          <i className="bi bi-dash"></i>
                        </button>
                        <span className="mx-3">{item.quantity}</span>
                        <button 
                          className="btn btn-sm btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "28px", height: "28px" }}
                          onClick={() => updateQuantity(index, item.quantity + 1)}
                        >
                          <i className="bi bi-plus"></i>
                        </button>
                      </div>
                    </td>
                    <td className="text-end fw-semibold">₹{(price * item.quantity).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="bg-light p-4 rounded mt-4">
          <div className="row">
            <div className="col-md-6">
              <div className="text-muted mb-2">Total Items</div>
              <div className="fs-5 fw-semibold">{cartItems.length}</div>
            </div>
            <div className="col-md-6">
              <div className="mb-2">
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Subtotal:</span>
                  <span>₹{totalCartPrice.toFixed(2)}</span>
                </div>
              </div>
             {/* Show Taxes */}
{taxDetails.map((tax, index) => (
  <div key={`tax-${index}`} className="mb-2">
    <div className="d-flex justify-content-between">
      <span className="text-muted">{tax.tax_name}:</span>
      <span>₹{tax.tax_amount.toFixed(2)}</span>
    </div>
  </div>
))}

{/* Show Charges */}
{chargeDetails.map((charge, index) => (
  <div key={`charge-${index}`} className="mb-2">
    <div className="d-flex justify-content-between">
      <span className="text-muted">{charge.charges_name}:</span>
      <span>₹{charge.charges_amount.toFixed(2)}</span>
    </div>
  </div>
))}

              <div className="border-top pt-2">
                <div className="d-flex justify-content-between fw-bold fs-5">
                  <span>Total:</span>
                  <span>₹{(totalCartPrice + taxAmount + chargeAmount).toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer className="border-top-0 pt-0">
    <Button 
      variant="outline-secondary" 
      onClick={() => setShowCartModal(false)}
      className="px-4 py-2 rounded-1"
    >
      Close
    </Button>
    <Button 
      variant="primary" 
      onClick={placeOrder}
      disabled={ !selectedPayMode || cartItems.length === 0}
      className="px-4 py-2 rounded-1 d-flex align-items-center gap-2 fw-semibold"
    >
      <i className="bi bi-check-circle-fill"></i>
      Confirm Order
    </Button>
  </Modal.Footer>
</Modal>



    {/* Existing Modals and UI below... */}
  </Layout>

  );
};

export default POSBilling;
